module.exports = __webpack_public_path__ + "img/icon_2_47.d69cd020.png";